import { getRequest, getRequestV2, postRequestV2 } from '../../methods';

const getJiraIssues = (teamId, startDate, endDate) =>
  getRequest(
    `jira/goals/${teamId}?&start_date=${startDate}&end_date=${endDate}`
  );

const getJiraProjects = () => getRequest('jira_projects    ');

const getJiraProjectsByGoal = goalId =>
  getRequestV2(`jira/projects?goal_id=${goalId}`);

const getJiraProjectIssues = (
  projectId,
  goalId,
  search,
  issueType,
  statusCategory
) => {
  const params = new URLSearchParams();
  params.set('goal_id', goalId);
  if (search) params.set('search', search);
  if (issueType) params.set('issue_type', issueType);
  if (statusCategory) params.set('status_category', statusCategory);
  return getRequestV2(`jira/projects/${projectId}/issues?${params.toString()}`);
};

const getJiraProjectIssueTypes = (projectId, goalId) =>
  getRequestV2(`jira/projects/${projectId}/issue_types?goal_id=${goalId}`);

const linkJiraIssues = payload => postRequestV2('jira/issues', payload);

const jira = {
  getJiraIssues,
  getJiraProjects,
  getJiraProjectsByGoal,
  getJiraProjectIssues,
  getJiraProjectIssueTypes,
  linkJiraIssues,
};

export default jira;
